/**
 * Текстовые блоки разворота (01-SPEC.md §3.10).
 *
 * Ключевой инвариант модели: положение текста — вторая, **независимая** ось.
 * Оно не влияет ни на размер картинки, ни на промпт (§3.10.1).
 */
import { z } from 'zod';
/** Все положения текста, встречающиеся хотя бы в одной раскладке (01-SPEC.md §3.10.2). */
export const TEXT_POSITIONS = [
    'left',
    'right',
    'top',
    'bottom',
    'top-left',
    'top-right',
    'bottom-left',
    'bottom-right',
];
export const TextPositionSchema = z.enum(TEXT_POSITIONS);
export const TextBlockSchema = z.object({
    /** Идентификатор слота раскладки: `slot-0`, `slot-1`. */
    slotId: z.string().min(1),
    /** Текст блока; `\n` — жёсткий перенос строки, каждая строка получает свою плашку. */
    text: z.string(),
    position: TextPositionSchema,
    textColor: z.string().min(1).optional(),
    highlightColor: z.string().min(1).optional(),
    /**
     * Пользователь правил разбивку руками — автоматический пересчёт блок не трогает
     * (01-SPEC.md §3.10.6).
     */
    manual: z.boolean().optional(),
});
/** Идентификатор слота по его порядковому номеру. */
export function slotId(index) {
    return `slot-${index}`;
}
//# sourceMappingURL=text-block.js.map